export const productListItemAdvantagesProps = () => ({
  advantages: {
    type: Array,
    required: false,
    default: []
  },
  maxLength: {
    type: Number,
    required: false,
    default: 37
  },
  advantagesTitle: {
    type: String,
    required: false,
    default: "les avantages"
  },
  // Force le texte "vos avantages (pour le panier)"
  showFirstLabel: {
    type: Boolean,
    required: false,
    default: true
  },
  availableQuantity: {
    type: Number,
    required: false,
    default: 0
  },
  // Permet ou non d'afficher les boutons d'action (acheter le lot, voir les panachages...)
  // On ne le permet pas dans le tunnel
  showActions: {
    type: Boolean,
    required: false,
    default: true
  },
  context: {
    type: String,
    required: false,
    default: null
  }
});

export const productListItemAdvantagesEmits = () => (["setQuantity", "showPanachage", "lotAdded"]);

export const useProductListItemAdvantages = (emit) => {
  const setQuantity = (quantity) => {
    emit("setQuantity", quantity);
  };

  const canDisplayPanachage = (item, context, showActions) => {
    return (
      context !== "productMixes" &&
      showActions &&
      item.lot === 2 &&
      item.lien_panachage_produits
    );
  };

  return { setQuantity, canDisplayPanachage };
};
